import * as React from "react";
import {
  Edit,
  TabbedShowLayout,
  SelectInput,
  required,
  ReferenceField,
  TextField,
  ArrayInput,
  SimpleFormIterator,
  TextInput,
  maxValue,
  minValue,
  NumberInput,
  ReferenceInput,
  AutocompleteInput,
  useTranslate,
  TabbedForm,
} from "react-admin";
import { GAS_BRAND_MERCHANT_STATUSES } from "@local/app/constants/index.js";
import { Title, CustomToolbar } from "../../shared/components/index.js";
import Merchants from "./merchants.js";

const TabbedFormTabs = () => {
  const t = useTranslate();
  const plugins = JSON.parse(localStorage.getItem("plugins"));
  const merchant = localStorage.getItem("name");
  const nonDefaultClientRequires = [
    plugins.datexPayment,
    plugins.datexCoupon,
    plugins.multiplePaymentGateways,
  ];

  const renderOptionText = (record) => (
    <span key={record.id}>
      <img
        src={record?.url}
        width={15}
        height={15}
        style={{ marginRight: "5px" }}
      />
      {record.name}
    </span>
  );

  return (
    <TabbedShowLayout>
      <TabbedShowLayout.Tab label="resources.GasBrandMerchant.source.infoTab.info">
        <ReferenceField source="gas_brand_id" reference="GasBrand">
          <TextField
            source="name"
            sx={{ fontSize: "16", fontWeight: "bold" }}
          />
        </ReferenceField>
        <ReferenceInput source="logo_file_id" reference="File">
          <AutocompleteInput
            sx={{
              width: "20%",
              "@media (max-width:900px)": {
                width: "100%",
              },
            }}
            inputText={(record) => record.name}
            emptyText={t("resources.GasBrandMerchant.source.no_value")}
            optionText={renderOptionText}
            optionValue="id"
            debounce={10}
            filterToQuery={(searchText) => ({ name: searchText })}
          />
        </ReferenceInput>
        {plugins &&
          (plugins.datexPayment || plugins.datexApiPayment) &&
          Merchants[merchant]?.EditGasBrandMerchantInfo()}
        <SelectInput
          sx={{
            width: "20%",

            "@media (max-width:900px)": {
              width: "100%",
            },
          }}
          source="status"
          validate={[required()]}
          choices={Object.keys(GAS_BRAND_MERCHANT_STATUSES).map((status) => {
            if (status === "blocked") {
              return;
            }

            return {
              id: status,
              name: `resources.GasBrandMerchant.source.status.${status}`,
            };
          })}
        />
      </TabbedShowLayout.Tab>
      <TabbedShowLayout.Tab label="resources.GasBrandMerchant.source.infoTab.fuels">
        {plugins &&
          nonDefaultClientRequires.some((plugin) => plugin === true) &&
          Merchants[merchant].EditGasBrandMerchantFuel()}
        {nonDefaultClientRequires.every((plugin) => plugin === false) && (
          <ArrayInput source="fuels" label="">
            <SimpleFormIterator
              inline
              disableClear={true}
              disableReordering={true}
              disableRemove={true}
              sx={{
                "& .RaSimpleFormIterator-line > .MuiFormControl-root": {
                  width: "20%",
                  minWidth: "200px",
                  "@media (max-width: 900px)": {
                    width: "100%",
                  },
                },
              }}
            >
              <TextInput
                sx={{
                  width: "20%",
                  "@media (max-width:900px)": {
                    width: "100%",
                  },
                }}
                source="name"
                label="resources.GasBrandMerchant.fuels.name"
                validate={[required()]}
                inputProps={{ maxLength: 55, minLength: 1 }}
              />
              <NumberInput
                source="regular_price"
                label="resources.GasBrandMerchant.fuels.regular_price"
                validate={[required(), maxValue(2147483647), minValue(0)]}
              />
              <NumberInput
                source="discount_price"
                label="resources.GasBrandMerchant.fuels.discount_price"
                validate={[required(), maxValue(2147483647), minValue(0)]}
              />
              <SelectInput
                source="status"
                label="resources.GasBrandMerchant.fuels.status"
                validate={[required()]}
                choices={Object.keys(GAS_BRAND_MERCHANT_STATUSES).map(
                  (status) => {
                    if (status === "blocked") {
                      return;
                    }

                    return {
                      id: status,
                      name: `resources.GasBrandMerchant.source.status.${status}`,
                    };
                  }
                )}
              />
            </SimpleFormIterator>
          </ArrayInput>
        )}
      </TabbedShowLayout.Tab>
      {plugins && plugins.multiplePaymentGateways && (
        <TabbedShowLayout.Tab label="resources.GasBrandMerchant.source.infoTab.coords">
          {Merchants[merchant]?.EditGasBrandMerchantCoords()}
        </TabbedShowLayout.Tab>
      )}
    </TabbedShowLayout>
  );
};

const editGasBrandMerchant = () => (
  <Edit
    title={<Title source="name" />}
    mutationMode="pessimistic"
    redirect="show"
  >
    <TabbedForm
      toolbar={<CustomToolbar />}
      tabs={<TabbedFormTabs variant="scrollable" scrollButtons="auto" />}
    ></TabbedForm>
  </Edit>
);

export default editGasBrandMerchant;
